module.exports = __webpack_public_path__ + "media/images/about/b3@2x-8c9f40ee093f57b553c4346fc97b84c1.png";